module.exports = __webpack_public_path__ + "img/ButtonBg.4b9bff52.jpg";